export const getOSFromUserAgent = () => {
  const ua = navigator.userAgent
  const OSs = ['Windows', 'Mac OS', 'Linux']

  return OSs.filter(item => {
    const regex = new RegExp(item, 'gi')
    return regex.test(ua)
  })[0]
}
